import i18n from 'i18next';
import Backend from 'i18next-http-backend';

import config from "config";

const { language, langs } = config;
const lng = langs.includes(localStorage.language) ? localStorage.language : language;

await i18n.use(Backend).init({
    lng,
    fallbackLng: language,
    locales: langs,
    debug: true, // Enable debug to see what's happening
    
    backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    interpolation: {
        escapeValue: false,
    },

});

export default i18n;